import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Blank layout without navbar or footer
 * Used for full-screen pages like the welcome page
 */
export default function BlankLayout() {
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
} 